import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useLocation,useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import '../style/categoryList.css';
import Breadcrumb from '../../../Component/breadcrumb/Breadcrumb';
import SearchFilter from "../../../Component/search/Searchlist"
import MobileFilter from '../../../Component/Layout/MobileFilter/MobileFilter';
import ProductShorting from '../../../Component/Common/ProductShorting';
import { getQualityProductUrl } from "../../../utils/url.utils";
import { fetchProductList } from "../redux/ProductList.slice";
import noproduct from "../../../assets/images/Noproduct-Found.png";

export const CollectionListPage = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const {
    products = [],
    loading,
  } = useSelector((state) => state.product);
  const [search, setSearch] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!slug) return;
    const params = new URLSearchParams(location.search);
    const filters = {};
    params.forEach((value, key) => {
      if (filters[key]) {
        if (Array.isArray(filters[key])) {
          filters[key].push(value);
        } else {
          filters[key] = [filters[key], value];
        }
      } else {
        filters[key] = value;
      }
    });

    dispatch(
      fetchProductList({
        slug,
        filters,
      })
    );

  }, [dispatch, slug, location.search]);

const filteredProducts = useMemo(() => {
  if (!Array.isArray(products)) return [];
  const keyword = search.trim().toLowerCase();
  if (!keyword) return products;
  return products.filter((product) =>
    product.qualityName?.toLowerCase().includes(keyword)
  );
}, [products, search]);


  const breadcrumbItems = [
    {
      name: slug
        ? slug
          .replace(/-/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase())
        : "",
      path: location.pathname,
    },
  ].filter(item => item.name);

  return (
    <>
      <div style={{ background: "#eeeeee" }}>
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <div className="productlist-header serachsectionlisting">
        <div className="container mb-1">
          <div className="row">
            <div className="col-12 col-md-5">
              <p> Showing {products.length} items </p>
            </div>
            <div className="col-12 col-md-7">
              <div className='d-flex flesend' style={{ justifyContent: "flex-end" }}>

                 <SearchFilter
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                <ProductShorting />
                <div className="FILTERMOBILE w-00M">
                  <MobileFilter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="category-List">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-6 col-12">

              {loading ? (
                <Skeleton
                  height={50}
                  width="100%"
                  borderRadius={5}
                />
              ) : (
                products.length > 0 && (
                  <div className='Bardcom-Desktop-filter'>
                    <div className="row">
                      <div className="col-md-6 col-12">
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <p
                            style={{
                              textAlign: "left",
                              color: "rgb(127 127 127)",
                              marginBottom: "0",
                              marginTop: "2px"
                            }}
                          >
                            Showing <b>{products.length}</b> items
                          </p>
                        </div>
                      </div>

                      <div className="col-md-6 col-12">
                        <div
                          className='d-flex justify-content-end'
                          style={{ gap: "9px" }}
                        >
                          <SearchFilter
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                           <ProductShorting />
                          <div className="FILTER-MOBILE">
                            <MobileFilter />
                          </div>
                          <MobileFilter />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}

              <div className='row'>
                {loading ? (
                  Array.from({ length: 8 }).map((_, index) => (
                    <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
                      <Skeleton height={200} />
                      <Skeleton width="80%" />
                    </div>
                  ))
                ) : filteredProducts.length > 0 ? (
                  filteredProducts.map((product, index) => (
                    <div
                      key={product.id}
                      className="col-6 col-md-6 col-lg-3"
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{
                        duration: 0.1,
                        delay: index * 0.05,
                        ease: "easeOut",
                      }}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          getQualityProductUrl(product.qualityNameSlug)
                        )
                      }
                    >
                      <div className="border-0 p-2 mt-1 product-card">
                        <div className="relative overflow-hidden mb-1">
                          <Link to={getQualityProductUrl(`${product.qualityNameSlug}`)}>
                             <img
                                  src={product.imagePath}
                                  alt={product.qualityName}
                                  className="product-image"
                                  loading={index < 4 ? "eager" : "lazy"}
                                  fetchPriority={index < 4 ? "high" : "auto"}
                                  decoding="async"
                                />
                          </Link>
                        </div>
                        <div className="text-center mt-1">
                          <Link
                            to={getQualityProductUrl(product.qualityNameSlug)}
                            className="text-gray-600 text-lg text-decoration-none inline-block"
                            style={{
                              backgroundColor: "rgb(242 242 242)",
                              borderRadius: "3px",
                              whiteSpace: "nowrap",
                              width:"100%",
                              padding:"11px"
                            }}
                          >
                              {product.qualityName}
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <img src={noproduct} alt="no product" style={{ width: "140px", margin: "0 auto" }} />
                    <h4> No products found. </h4>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
